import classNames from 'classnames'
import { MdArrowForward } from 'react-icons/md'

import type { PropsWithChildren, ReactElement, ReactNode } from 'react'

import './styles.scss'

export interface Props {
  className?: string
  clickable?: boolean
  icon?: ReactNode
  infoTitle?: ReactNode
  onClick?: VoidFunction
  title: string
}

const NavigationBlock = ({
  children,
  className,
  clickable,
  icon,
  infoTitle,
  onClick,
  title,
}: PropsWithChildren<Props>): ReactElement => {
  return (
    <div
      className={classNames('navigation-block-component', className, {
        clickable: !!clickable,
      })}
      onClick={onClick}
    >
      <div className="info-title">{infoTitle}</div>
      <div className="header">
        <div className="title-container" role="heading">
          {icon ? <div className="title-icon">{icon}</div> : null}
          <span>{title}</span>
          {clickable ? (
            <div className="arrow-container">
              <MdArrowForward size={21} />
            </div>
          ) : null}
        </div>
      </div>
      {children}
    </div>
  )
}

export default NavigationBlock
